import script from "./PlyaerInfoView.vue?vue&type=script&setup=true&lang=js"
export * from "./PlyaerInfoView.vue?vue&type=script&setup=true&lang=js"

import "./PlyaerInfoView.vue?vue&type=style&index=0&id=18131723&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-18131723"]])

export default __exports__